export default "__VITE_ASSET__O8DozL$A__"